import React from 'react';



const InformationArea = () => {
  return (
    <section id="myservice">
      <ul>
        <li><a href="https://mihiraki.app" target="_blank" rel="noopener"><img src="/assets/img/bnr_mihiraki.png" alt="MIHIRAKI 没入型マンガリーダーアプリ" /></a></li>
        <li><a href="https://housnap.net" target="_blank" rel="noopener"><img src="/assets/img/bnr_housnap.png" alt="HOUSNAP デスク・部屋の投稿プラットフォーム" /></a></li>
      </ul>
    </section>
  );
};

export default InformationArea;